import { SupportedChainId as ChainId } from "../constants/chains";

export type AddressMap = { [chainId: number]: string };

export const INFURA_API_KEY = process.env.INFURA_API_KEY || "";
export const SCAN_API_KEY = process.env.SCAN_API_KEY || "";

export const POOL_ADDRESS: AddressMap = {
  [ChainId.FUJI]: process.env.POOL_ADDRESS_AVAX || "",
  [ChainId.BSC]: process.env.POOL_ADDRESS_BSC || "",
  [ChainId.AVAX]: process.env.POOL_ADDRESS_AVAX || "",
};

export const LP_POOL_ADDRESS: AddressMap = {
  [ChainId.FUJI]: process.env.LP_POOL_ADDRESS || "",
  [ChainId.BSC]: process.env.LP_POOL_ADDRESS || "",
  [ChainId.AVAX]: process.env.LP_POOL_ADDRESS || "",
};

export const TOKEN_SECOND_ADDRESS: AddressMap = {
  [ChainId.FUJI]: process.env.TOKEN_SECOND_ADDRESS || "",
  [ChainId.BSC]: process.env.TOKEN_SECOND_ADDRESS ||  "",
  [ChainId.AVAX]: process.env.TOKEN_SECOND_ADDRESS || "",
};

export const TOKEN_LP_BNB_SECOND_ADDRESS: AddressMap = {
  [ChainId.FUJI]: process.env.TOKEN_LP_BNB_SECOND_ADDRESS || "",
  [ChainId.BSC]: process.env.TOKEN_LP_BNB_SECOND_ADDRESS || "",
  [ChainId.AVAX]: process.env.TOKEN_LP_BNB_SECOND_ADDRESS || "",
};


// // Mainnet

// import { SupportedChainId as ChainId } from "../constants/chains";

// export type AddressMap = { [chainId: number]: string };

// export const INFURA_API_KEY = "c3d9cae277504405a9eeed5d27d77cdb";
// export const SCAN_API_KEY = "Q5EJNF2NE7KS12NG2K99WMES1REEM9882Q";

// export const POOL_ADDRESS: AddressMap = {
//   [ChainId.FUJI]: "0x79604B938265Bc091B039a76eA99Cc0d1d6F2279",
//   [ChainId.BSC]: "0x79604B938265Bc091B039a76eA99Cc0d1d6F2279",
//   [ChainId.AVAX]: "0x79604B938265Bc091B039a76eA99Cc0d1d6F2279",
// };

// export const LP_POOL_ADDRESS: AddressMap = {
//   [ChainId.FUJI]: "", // AllocationPool
//   [ChainId.BSC]: "",
//   [ChainId.AVAX]: "",
// };

// export const TOKEN_SECOND_ADDRESS: AddressMap = {
//   [ChainId.FUJI]: "0x7979871595b80433183950ab6c6457752b585805",
//   [ChainId.BSC]: "",
//   [ChainId.AVAX]: "0x7979871595b80433183950ab6c6457752b585805",
// };

// export const TOKEN_LP_BNB_SECOND_ADDRESS: AddressMap = {
//   [ChainId.FUJI]: "0xF601AFF9c4DCcCd8cB8F2ce48652656102ca4CD0",
//   [ChainId.BSC]: "",
//   [ChainId.AVAX]: "",
// };
